export const CLUB_PRIVACIES = {
    PRIVATE: 0,
    OPEN: 1,
};
